/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-26.
 * Displayed when route does not exist.
 */
import React, { Component } from 'react';

class EmptyList extends Component {
    render() {
        return (
            <div style={styles.container}>
                <h4>Sin resultados.</h4>
            </div>
        );
    }
}

const styles = {
    container: {
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    img: {
        marginTop: 50,
        marginBottom: 100
    }
};

export default EmptyList;



// WEBPACK FOOTER //
// ./components/layout/emptyList.js